import { call, put, takeLatest } from 'redux-saga/effects';
import actionCreators from '../../actions/communities/manager_recruitments';
import 'babel-polyfill';

// 使われていない

/**
 * アンバサダー募集詳細取得
 */
function* getManagerRecruitmentDetail(action) {
  try {
    const result = yield call(function () {
      const method = 'GET';
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      return fetch(`/api/companies/manager_recruitments/${action.payload.id}`, {
        method,
        headers,
      })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(
      actionCreators.communities.managerRecruitments.success({
        managerRecruitmentDetail: result,
      })
    );
  } catch (e) {
    yield put(
      actionCreators.communities.managerRecruitments.failure({
        managerRecruitmentDetail: {},
      })
    );
  }
}

/**
 * 都道府県リスト取得
 */
// eslint-disable-next-line no-unused-vars
function* getPrefList(_action) {
  try {
    const result = yield call(function () {
      const method = 'GET';
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      return fetch('/api/locations/pref_list', { method, headers })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(
      actionCreators.communities.managerRecruitments.success({
        prefList: result.prefs,
      })
    );
  } catch (e) {
    yield put(
      actionCreators.communities.managerRecruitments.failure({ prefList: [] })
    );
  }
}

/**
 * 市区町村リスト取得
 */
function* getCityList(action) {
  try {
    const result = yield call(function () {
      const method = 'GET';
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      return fetch(
        `/api/locations/city_list?pref_id=${action.payload.prefId}`,
        { method, headers }
      )
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(
      actionCreators.communities.managerRecruitments.success({
        cityList: result.cities,
      })
    );
  } catch (e) {
    yield put(
      actionCreators.communities.managerRecruitments.failure({ cityList: [] })
    );
  }
}

/**
 * マイサークルリスト取得
 */
// eslint-disable-next-line no-unused-vars
function* getMyCircleList(_action) {
  try {
    const result = yield call(function () {
      const method = 'GET';
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      return fetch('/api/mypage/my_circles', { method, headers })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(
      actionCreators.communities.managerRecruitments.success({
        myCircleList: result.users_circles,
      })
    );
  } catch (e) {
    yield put(
      actionCreators.communities.managerRecruitments.failure({
        myCircleList: [],
      })
    );
  }
}

/**
 * 登録
 */
function* createManagerRecruitsUsers(action) {
  try {
    const result = yield call(
      function (
        companiesCirclesManagerRecruitId,
        companyId,
        _communityId,
        userId,
        circleId,
        userComment,
        userPrefId,
        userAddress,
        userPostal,
        userTel,
        userFamilyname,
        userFirstname,
        facebookUrl,
        twitterUrl,
        instagramUrl
      ) {
        const method = 'POST';
        const body = JSON.stringify({
          companies_circles_manager_recruit_id:
            companiesCirclesManagerRecruitId,
          company_id: companyId,
          // community_id: communityId,
          user_id: userId,
          circle_id: circleId,
          user_comment: userComment,
          user_pref_id: userPrefId,
          user_address: userAddress,
          user_postal: userPostal,
          user_tel: userTel,
          user_familyname: userFamilyname,
          user_firstname: userFirstname,
          facebook_url: facebookUrl,
          twitter_url: twitterUrl,
          instagram_url: instagramUrl,
        });
        const headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        };
        return fetch('/api/companies/manager_recruits_users_create', {
          method,
          headers,
          body,
        })
          .then((response) => response.json())
          .catch((xhr) => {
            throw xhr.status;
          });
      },
      action.payload.companiesCirclesManagerRecruitId,
      action.payload.companyId,
      action.payload.communityId,
      action.payload.userId,
      action.payload.circleId,
      action.payload.userComment,
      action.payload.userPrefId,
      action.payload.userAddress,
      action.payload.userPostal,
      action.payload.userTel,
      action.payload.userFamilyname,
      action.payload.userFirstname,
      action.payload.facebookUrl,
      action.payload.twitterUrl,
      action.payload.instagramUrl
    );
    if (result) {
      yield put(
        actionCreators.communities.managerRecruitments.success({
          modalIsOpen: true,
          createStatus: 'success',
          createdCircleId: result.circle_id,
        })
      );
    } else {
      yield put(
        actionCreators.communities.managerRecruitments.failure({
          modalIsOpen: true,
          createStatus: 'error',
        })
      );
    }
  } catch (e) {
    yield put(
      actionCreators.communities.managerRecruitments.failure({
        modalIsOpen: true,
        createStatus: 'error',
      })
    );
  }
}

export default function* () {
  // アンバサダー募集詳細取得
  yield takeLatest(
    actionCreators.communities.managerRecruitments.getManagerRecruitmentDetail,
    getManagerRecruitmentDetail
  );
  // 都道府県リスト取得
  yield takeLatest(
    actionCreators.communities.managerRecruitments.getPrefList,
    getPrefList
  );
  // 市区町村リスト取得
  yield takeLatest(
    actionCreators.communities.managerRecruitments.getCityList,
    getCityList
  );
  // マイサークルリスト取得
  yield takeLatest(
    actionCreators.communities.managerRecruitments.getMyCircleList,
    getMyCircleList
  );
  // 登録
  yield takeLatest(
    actionCreators.communities.managerRecruitments.createManagerRecruitsUsers,
    createManagerRecruitsUsers
  );
}
